import { Label } from "@/components/base/input/label";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";
import { cx } from "@/utils/cx";

type LabelWithTooltipProps = {
  label: string;
  tooltip: string;
  description?: string;
  className?: string;
};

export const LabelWithTooltip = ({ label, tooltip, description, className }: LabelWithTooltipProps) => (
  <Label className={cx("text-sm text-tertiary flex items-center", className)}>
    {label}
    <Tooltip title={tooltip} description={description}>
      <TooltipTrigger className="ml-1.5 cursor-help">
        <span className="inline-flex items-center justify-center w-4 h-4 border border-quaternary rounded-full text-[10px] text-quaternary font-medium">
          i
        </span>
      </TooltipTrigger>
    </Tooltip>
  </Label>
);

type DisabledLabelProps = {
  label: string;
  tooltip?: string;
  description?: string;
};

export const DisabledLabel = ({ label, tooltip, description }: DisabledLabelProps) => (
  <div className="flex items-center gap-2">
    {tooltip ? (
      <LabelWithTooltip label={label} tooltip={tooltip} description={description} className="text-quaternary" />
    ) : (
      <Label className="text-sm text-quaternary">{label}</Label>
    )}
  </div>
);
